import { Component, Inject, OnInit } from '@angular/core';
import { MODAL_DATA } from '../../../helpers/modal.tokens';
import { MatDialogRef } from '@angular/material/dialog';

export interface ModalText {
  key: string;
  params?: Record<string, string | number>;
}

export interface GenericModalConfig {
  title: ModalText,
  description: ModalText,
  buttons: Array<{
    labelKey: string,
    value: any,
    className: string
  }>;
}

@Component({
  selector: 'app-generic-confirm-modal',
  templateUrl: './generic-confirm-modal.component.html',
  styleUrls: ['./generic-confirm-modal.component.scss']
})
export class GenericConfirmModalComponent {

  constructor(
    @Inject(MODAL_DATA) public config: GenericModalConfig,
    private dialogRef: MatDialogRef<any>
  ) { }

  close(result: any) {
    this.dialogRef.close(result);
  }
}
